import { render, staticRenderFns } from "./Joindea.vue?vue&type=template&id=59c2b9e2&scoped=true"
import script from "./Joindea.vue?vue&type=script&lang=js"
export * from "./Joindea.vue?vue&type=script&lang=js"
import style0 from "./Joindea.vue?vue&type=style&index=0&id=59c2b9e2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2b9e2",
  null
  
)

export default component.exports